import React, { useState } from "react";
import "./TagsInput.css";

const TagsInput = ({ value, onChange, disabled }) => {
    const [inputValue, setInputValue] = useState("");

    const tags = value ? value.split(",").map(t => t.trim()).filter(Boolean) : [];

    const addTag = () => {
        const v = inputValue.trim();
        if (v !== "" && !tags.includes(v)) {
            const newTags = [...tags, v];
            onChange(newTags.join(","));
            setInputValue("");
        }
    };

    const removeTag = (tagToRemove) => {
        const newTags = tags.filter(tag => tag !== tagToRemove);
        onChange(newTags.join(","));
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            addTag();
        }
    };

    return (
        <div className="tags-inline">
            {tags.map((tag, index) => (
                <span key={index} className="chip">
                    {tag}
                    {!disabled && (
                        <button type="button" onClick={() => removeTag(tag)}>×</button>
                    )}
                </span>
            ))}
            {!disabled && (
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Digite e pressione Enter"
                />
            )}
        </div>
    );
};

export default TagsInput;
